import { createActionConst } from '../../../utils/action.utils';

const WRIKE_FOLDER_NAMESPACE = 'WRIKE_FOLDER';

export const STORE_WRIKE_FOLDER = createActionConst(WRIKE_FOLDER_NAMESPACE, 'STORE_WRIKE_FOLDER');
export const CLEAR_WRIKE_FOLDER = createActionConst(WRIKE_FOLDER_NAMESPACE, 'CLEAR_WRIKE_FOLDER');
